var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { logError } from '@core/logging';
import { fetcher } from '@embed/store/fetchers';
export function fetchFwaiAds({ xml, params, }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetcher({
                url: `${params === null || params === void 0 ? void 0 : params.api_host_ads}/api/fwai/ad_videos`,
                fetchParams: {
                    method: 'POST',
                    body: xml,
                    headers: {
                        'Content-Type': 'application/xml',
                    },
                },
            });
            const { ads } = yield response.json();
            return ads;
        }
        catch (error) {
            logError(error);
            return [];
        }
    });
}
export function fetchSsaiAds({ adUnit, adConfig, appContext, params, }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const placement = adConfig === null || adConfig === void 0 ? void 0 : adConfig.placements.filter((unit) => { var _a; return ((_a = unit.ad_tags[0]) === null || _a === void 0 ? void 0 : _a.id) === adUnit.id; });
            const response = yield fetcher({
                url: `${params === null || params === void 0 ? void 0 : params.api_host_ads}/api/ad_videos`,
                query: {
                    publisher_client_id: appContext === null || appContext === void 0 ? void 0 : appContext.publisherClientId,
                    channel: appContext === null || appContext === void 0 ? void 0 : appContext.username,
                    ad_setting_id: adConfig === null || adConfig === void 0 ? void 0 : adConfig.id,
                    placement_id: placement === null || placement === void 0 ? void 0 : placement[0].id,
                    ad_tag_id: adUnit.id,
                    ad_target_platform: adConfig === null || adConfig === void 0 ? void 0 : adConfig.ad_target_platform,
                    context: adConfig === null || adConfig === void 0 ? void 0 : adConfig.context,
                    presentation_type: adConfig === null || adConfig === void 0 ? void 0 : adConfig.presentation_type,
                    ads_count: 1,
                    page_url: (params === null || params === void 0 ? void 0 : params.page_url) ||
                        (typeof window !== 'undefined' ? window.location.href : ''),
                },
            });
            const { ads } = yield response.json();
            return ads || [];
        }
        catch (error) {
            logError(error);
            return [];
        }
    });
}
